module.exports = "<div class=\"section-header\">\r\n  <h2 [innerHtml]=\"text\"></h2>\r\n</div>"